import { Button, Space } from "antd";
import moment from "moment";
import ConfirmIcon from "../../../assets/icons/ConfirmIcon";
import { dbDateFormat } from "../../../constants/constants";
import { ModalComponentProps } from "../../../types";
import ModalCustomTitle from "../../common/ModalCustomTitle";
import CustomModal from "../../ui/CustomModal";

interface AssignGeneralAttendanceModalProps extends ModalComponentProps {
  handleSubmit: () => void;
  loading?: boolean;
  currentDate?: string;
}

export default function AssignGeneralAttendanceModal({
  handleClose,
  handleSubmit,
  loading,
  currentDate,
  ...rest
}: AssignGeneralAttendanceModalProps) {
  return (
    <CustomModal
      handleClose={handleClose}
      width={460}
      closeIcon={null}
      {...rest}
      footer={
        <Space className="w-full" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            size="middle"
            onClick={handleSubmit}
            loading={loading}
          >
            Move
          </Button>
        </Space>
      }
    >
      <ModalCustomTitle
        title="Are you sure?"
        icon={<ConfirmIcon />}
        iconClassName="!bg-[#fff2c4] disabled:!text-tint-warning"
        handleClose={handleClose}
      />

      <p className="text-body-text">
        Moving to "General Attendance" will un-assign the employee from all
        other shifts from{" "}
        {moment(currentDate, dbDateFormat).format("DD MMMM YYYY")} onwards.
      </p>
    </CustomModal>
  );
}
